import { useEffect, useState } from "react";
import { getUser } from "../../../../services/authService";
import { toast } from "react-toastify";
import {
  // insertVGMData,
  // insertAggregateVGMData,
  // insert5MVGMData,
  updateVGMData,
  updateAggregateVGMData,
  updateFiveMVGMData,
} from "../../../../services/VGMService";
import moment from "moment";
import Select from "react-select";
import Tooltips from "../../../Custom Components/tooltip"

const VGMDataEditableCell = ({
  value: initialValue,
  row: { original, index },
  column: { id },
  updateCellData,
  updateCellDataForWeighing_Date,
  allowToEdit,
  personName
}) => {
  const [value, setValue] = useState(initialValue);
  const [dateValue, setDateValue] = useState(
    moment(initialValue).format("YYYY-MM-DD")
  );
  const [timeValue, setTimeValue] = useState(
    moment(initialValue).format("HH:mm")
  );
  const [typing, setTyping] = useState(false);

  const user = getUser();

  const onChange = (e) => {
    setValue(e.target.value);
    setTyping(true);
  };

  useEffect(() => {
    setValue(initialValue);
    setDateValue(moment(initialValue).format("YYYY-MM-DD"));
    setTimeValue(moment(initialValue).format("HH:mm"));
  }, [initialValue]);

  async function onBlur() {
    setTyping(false);
    if (id) {
      updateCellData(index, id, value);
    }
    if (original.DataOf === "TRACTOR") {
    if (original.VGMId) {
      if (original[id] !== value) {
        try {
          updateVGMData({
            _id: `${original["VGMId"]}`,
            _columnName: `${id}`,
            _prevVal: original[id],
            _value: value,
            _userId: user.uid,
          });
          setTyping(false);
          toast.success(`"${id}" column updated with "${value}"`);
        } catch (error) {
          toast.error("Unable to update column");
        }
      }
    }
    }
    if (original.DataOf === "AGGREGATE") {
      if (original.VGMId) {
        if (original[id] !== value) {
          try {
            updateAggregateVGMData({
              _id: `${original["VGMId"]}`,
              _columnName: `${id}`,
              _prevVal: original[id],
              _value: value,
              _userId: user.uid,
            });
            setTyping(false);
            toast.success(`"${id}" column updated with "${value}"`);
          } catch (error) {
            toast.error("Unable to update column");
          }
        }
      }
    }
    if (original.DataOf === "5M") {
      if (original.VGMId) {
        if (original[id] !== value) {
          try {
            updateFiveMVGMData({
              _id: `${original["VGMId"]}`,
              _columnName: `${id}`,
              _prevVal: original[id],
              _value: value,
              _userId: user.uid,
            });
            setTyping(false);
            toast.success(`"${id}" column updated with "${value}"`);
          } catch (error) {
            toast.error("Unable to update column");
          }
        }
      }
    }
  }

  async function onBlurForJDPerson() {
    setTyping(false);
    const contactDetails = () => {
      if(value === "Mr. Pradeep Gaikwad"){
        return "9822034959"
      }
      if(value === "Mr. Raju Palve"){
        return "9921269323"
      }
      if(value === "Mr. Abulhaiyat khan"){
        return "8917428675"
      }
    }
    if (id) {
      updateCellData(index, id, value);
      updateCellData(index, "Mobile_Number", contactDetails());
    }
    if (original.DataOf === "TRACTOR") {
      if (original.VGMId) {
        if (original[id] !== value) {
          try {
            updateVGMData({
              _id: `${original["VGMId"]}`,
              _columnName: `${id}`,
              _prevVal: original[id] === null ? "" : original[id],
              _value: value,
              _userId: user.uid,
            });
            updateVGMData({
              _id: `${original["VGMId"]}`,
              _columnName: "Mobile_Number",
              _prevVal: original["Mobile_Number"] === null ? "" : original["Mobile_Number"],
              _value: contactDetails(),
              _userId: user.uid,
            });
            setTyping(false);
            toast.success(`"${id}" column updated with "${value}"`);
          } catch (error) {
            toast.error("Unable to update column");
          }
        }
      }
    }
    if (original.DataOf === "AGGREGATE") {
      if (original.VGMId) {
        if (original[id] !== value) {
          try {
            updateAggregateVGMData({
              _id: `${original["VGMId"]}`,
              _columnName: `${id}`,
              _prevVal: original[id] === null ? "" : original[id],
              _value: value,
              _userId: user.uid,
            });
            updateAggregateVGMData({
              _id: `${original["VGMId"]}`,
              _columnName: "Mobile_Number",
              _prevVal: original["Mobile_Number"] === null ? "" : original["Mobile_Number"],
              _value: contactDetails(),
              _userId: user.uid,
            });
            setTyping(false);
            toast.success(`"${id}" column updated with "${value}"`);
          } catch (error) {
            toast.error("Unable to update column");
          }
        }
      }
    }
    if (original.DataOf === "5M") {
      if (original.VGMId) {
        if (original[id] !== value) {
          try {
            updateFiveMVGMData({
              _id: `${original["VGMId"]}`,
              _columnName: `${id}`,
              _prevVal: original[id] === null ? "" : original[id],
              _value: value,
              _userId: user.uid,
            });
            updateFiveMVGMData({
              _id: `${original["VGMId"]}`,
              _columnName: "Mobile_Number",
              _prevVal: original["Mobile_Number"] === null ? "" : original["Mobile_Number"],
              _value: contactDetails(),
              _userId: user.uid,
            });
            setTyping(false);
            toast.success(`"${id}" column updated with "${value}"`);
          } catch (error) {
            toast.error("Unable to update column");
          }
        }
      }
    }
  }

  async function onBlurForWeighing_Date() {
    if (id === "Weighing_Date") {
      updateCellDataForWeighing_Date(index, id, dateValue, timeValue);
    }
    if (original.DataOf === "TRACTOR") {
      if (original.VGMId) {
        if (
          original[id] !== new Date(dateValue + "T" + timeValue).toISOString()
        ) {
          if (original[id] !== "Invalid date") {
            if (original[id] !== `${dateValue}T${timeValue}`) {
              try {
                updateVGMData({
                  _id: `${original["VGMId"]}`,
                  _columnName: `${id}`,
                  _prevVal: original[id],
                  _value: `${dateValue}T${timeValue}`,
                  _userId: user.uid,
                });
                toast.success(
                  `"${id}" column updated with "${moment(dateValue).format(
                    "DD-MM-YYYY"
                  )},${timeValue}"`
                );
              } catch (error) {
                toast.error("Unable to update column");
              }
            }
          }
        }
      }
    }
    if (original.DataOf === "AGGREGATE") {
      if (original.VGMId) {
        if (
          original[id] !== new Date(dateValue + "T" + timeValue).toISOString()
        ) {
          if (original[id] !== "Invalid date") {
            if (original[id] !== `${dateValue}T${timeValue}`) {
              try {
                updateAggregateVGMData({
                  _id: `${original["VGMId"]}`,
                  _columnName: `${id}`,
                  _prevVal: original[id],
                  _value: `${dateValue}T${timeValue}`,
                  _userId: user.uid,
                });
                toast.success(
                  `"${id}" column updated with "${moment(dateValue).format(
                    "DD-MM-YYYY"
                  )},${timeValue}"`
                );
              } catch (error) {
                toast.error("Unable to update column");
              }
            }
          }
        }
      }
    }
    if (original.DataOf === "5M") {
      if (original.VGMId) {
        if (
          original[id] !== new Date(dateValue + "T" + timeValue).toISOString()
        ) {
          if (original[id] !== "Invalid date") {
            if (original[id] !== `${dateValue}T${timeValue}`) {
              try {
                updateFiveMVGMData({
                  _id: `${original["VGMId"]}`,
                  _columnName: `${id}`,
                  _prevVal: original[id],
                  _value: `${dateValue}T${timeValue}`,
                  _userId: user.uid,
                });
                toast.success(
                  `"${id}" column updated with "${moment(dateValue).format(
                    "DD-MM-YYYY"
                  )},${timeValue}"`
                );
              } catch (error) {
                toast.error("Unable to update column");
              }
            }
          }
        }
      }
    }
  }
  if(id === "Shipper_Authorised_Name"){
    return (
      <Select
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        getOptionLabel={(person) => person.JD_Person}
        getOptionValue={(person) => person.JD_Person}
        options={personName}
        placeholder="Select Type..."
        className="VGM_JDPerson_dropdown"
        maxMenuHeight={200}
        name="Shipper_Authorised_Name"
        value={{ JD_Person: value }}
        onBlur={onBlurForJDPerson}
        onChange={(option) => setValue(option["JD_Person"])}
        isDisabled={!allowToEdit}
      />
    );
  }
  if (id === "Weighing_Date") {
    return (
      <>
        <input
          type="date"
          className="table_input"
          value={`${dateValue}`}
          onChange={(e) => setDateValue(e.currentTarget.value)}
          onBlur={onBlurForWeighing_Date}
          name={id}
          disabled={!allowToEdit}
        />
        <input
          type="time"
          className="table_input"
          value={`${timeValue}`}
          // step="3600"
          onChange={(e) => setTimeValue(e.currentTarget.value)}
          onBlur={onBlurForWeighing_Date}
          name={id}
          disabled={!allowToEdit}
        />
      </>
    );
  }

  if (id === "Container_Number" || id === "Container_Type" || id === "DataOf") {
    return (
      <input
        type="text"
        className="table_input"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={id}
        disabled
      />
    );
  }
  if (
    id === "shippername" ||
    id === "Weibridge_Address" ||
    id === "Weibridge_Reg_No"
  ) {
    return (
      <input
        type="text"
        className="table_input"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={id}
        disabled
      />
    );
  }

  if (id === "Weibridge_Address") {
    return (
      <textarea
        type="text"
        className="table_input"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={id}
        disabled
      />
    );
  }

  if (id === "Shipper_Lic_No" || id === "Mobile_Number") {
    return (
      <input
        type="number"
        className="table_input"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={id}
        disabled
      />
    );
  }

  if (id === "Container_Mass") {
    return (
      <input
        type="text"
        className="table_input"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={id}
        disabled={!allowToEdit}
      />
    );
  }

  if (id === "Remarks") {
    return (
      <Tooltips content={value} direction="left" typing={typing}>
        <input
          type="text"
          className="table_input"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={id}
          disabled={!allowToEdit}
        />
      </Tooltips>
    );
  }

  if (id === "Container_Weight" || id === "Weighing_Slip_No") {
    return (
      <input
        type="number"
        className="table_input"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={id}
        disabled={!allowToEdit}
      />
    );
  }
  var VGMTypeOptions = [
    { label: "Normal", value: "Normal" },
    { label: "Reefer", value: "Reefer" },
    { label: "Hazardous", value: "Hazardous" },
    { label: "Others", value: "Others" },
  ];
  if (id === "VGM_Type") {
    return (
      <Select
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        options={VGMTypeOptions}
        placeholder="Select Type..."
        className="Carrier_Type_dropdown"
        maxMenuHeight={200}
        name="VGM_Type"
        value={{ label: value }}
        onBlur={onBlur}
        onChange={(option) => setValue(option["label"])}
        isDisabled={!allowToEdit}
      />
    );
  }
  // if (id === "Action") {
  //   return (
  //     <OverlayTrigger
  //       placement="top"
  //       delay={{ show: 100, hide: 100 }}
  //       overlay={<Tooltip>Save</Tooltip>}
  //       >

  //     <i
  //       class="bx bxs-check-circle"
  //       style={{
  //         color: `${original.VGMId ? "gray" : "green"}`,
  //         transform: "scale(1.8)",
  //         marginLeft: "20px",
  //         cursor: "pointer",
  //       }}
  //       onClick={actionClickHandler}
  //         disable={original.VGMId ? true : false}
  //         ></i>
  //     </OverlayTrigger>
  //   );
  // }
  // if (id === "generate_pdf") {
  //   return (
  //     <i
  //       class="bx bxs-file-pdf"
  //       style={{
  //         color: "red",
  //         transform: "scale(1.8)",
  //         marginLeft: "45px",
  //         cursor: "pointer",
  //       }}
  //       onClick={downloadClickHandler}
  //     ></i>
  //   );
  // }
  else {
    return (
      <input
        type="text"
        className="table_input"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={id}
        disabled={!allowToEdit}
      />
    );
  }
};

export const defaultVGMDataColumn = {
  Cell: VGMDataEditableCell,
};
